import {IntermediatePart} from "../../intermediatePart";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import {LayoutType, ShowerComboTubType} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {IS_BATHROOM_OLD_BV_SCENE} from "../../../../../config";
import {ShowerAccessories} from "../../parts/showerAccessories";

export default class ShowerDoor extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_door';
    this.partName = 'Shower Door';
    this.translateId = "visualizer.bathroom.shower.shower_door";
    this.visible = true;
    this.isStoneFeature = false;
    this.canBeDisabled = true;
    this.layerPriority = 5;

    /* only shower door properties */
    if (isChild) {
      this.previouslySelectedFeatures = {};
      this.oneLayerPosition = true;
      Object.keys(LayoutType).forEach(layoutName => {
        this.previouslySelectedFeatures[layoutName] = {};
      })
    }
    this.currentShowerBodyId = ""; // for example "custom-a-60in-30x8"
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    return super.load_(dbFeature, new ShowerDoor());
  }

  navigationSubItems(filters, searchText) {
    return this.navigationSubItemsWithSides(filters, searchText);
  }

  disabledClick() {
    const showerParent = this.getParent();
    const showerDoorHandle = showerParent.showerDoorHandle;
    if (showerDoorHandle) {
      showerDoorHandle.disabled = this.disabled;
    }
    const accParent = showerParent.layout.parts[ShowerAccessories.id]
    if (!this.disabled && accParent && accParent.showerRod && !accParent.showerRod.disabled) {
      accParent.showerRod.disabled = true
    }
  }

  handleClick() {
    super.handleClick();
    if (!this.notAvailableInVisualizer && !getFeatureIsLocked(this)) {
      // this.getParent().getParent().setShowerTubCombo();
      // let doorWithLiner = false;
      // if(this.metaData && this.metaData.length) {
      //   const activeDoorMetadata = this.metaData.find(metaDataObject => metaDataObject.isFor);
      //   const showerPanValues = activeDoorMetadata.conditions.find(condition => condition.name === "BathtubLiner");
      //   if (showerPanValues) {
      //     doorWithLiner = true;
      //   }
      // }
      // this.getParent().getParent().setLinerActive(doorWithLiner);
      const shower = this.getParent().getParent();
      const showerPanCondition = this.metaData["ShowerPan"];
      if (!shower.showerTubComboIsActive()) {
        shower.showerFloorIsActive = showerPanCondition && showerPanCondition.includes("Threshold");
      }
      const accParent = shower.layout.parts[ShowerAccessories.id]
      if (accParent && accParent.showerRod && !accParent.showerRod.disabled) {
        accParent.showerRod.disabled = true
      }
      if(!this.matchesMetaForArrayOfConditions(this.getParent().getArrayOfConditions())) {
        const showerSizeValues = this.metaData["ShowerSize"];
        const showerBodyParent = this.getParent().getParent().showerBody;
        if (showerSizeValues) {
          const showerBodyThatFits = showerBodyParent.features.filter(showerBodyFeature => {
            const showerSizeValues2 = showerBodyFeature.metaData["ShowerSize"];
            return showerSizeValues.some(condValue => {
              return showerSizeValues2.some(condValue2 => condValue === condValue2);
            });
          });
          if (showerBodyThatFits.length && showerBodyThatFits.every(shBody => shBody.partName !== showerBodyParent.activeFeature.partName)) {
            let showerBodyToSet = showerBodyThatFits.find(shBody => {
              return shBody.showerDimensions === showerBodyParent.activeFeature.showerDimensions
            }) || showerBodyThatFits[0];
            showerBodyParent.showerBodySelectedByUser = true;
            showerBodyParent.activeFeature = showerBodyToSet;
          }
        }
      }
      this.featureClicked();
    }
  }

  setLayers(layout) {
    const showerParent = this.getParent();
    const comboParent = showerParent.layout.parts[ShowerTubCombo.id];
    if (showerParent.showerTubComboIsActive() && comboParent.bottomTub === ShowerComboTubType.walk_in_tub) {
      super.hideLayers();
      return;
    }
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    const comboParent = showerParent.layout.parts[ShowerTubCombo.id];
    const showerTubComboIsActive = showerParent.showerTubComboIsActive();
    let conditions = super.getArrayOfConditions(); //roomLayout
    conditions.push({
      propName: IS_BATHROOM_OLD_BV_SCENE ? "Type" : "Shower",
      propValue: showerTubComboIsActive
        ? comboParent.bottomTub === ShowerComboTubType.walk_in_tub ? "WalkInTub" : "Tub"  // WalkInTub removes items from nav
        : "Pan"
    })
    conditions.push({
      propName: "ShowerSize",
      propValue: showerParent.showerSize()
    })
    return conditions
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Shower.ShowerDoor;
    }
  }
}
